module.exports = __webpack_public_path__ + "img/people_white.0a429430.svg";